export default "__VITE_ASSET__CfKZ4Sed__"